import React from 'react';
import {
  Text,
  StyleSheet,
  TouchableOpacity,
  Platform,
  Dimensions,
} from 'react-native';
import { useNavigation, useRoute } from '@react-navigation/native';
import { ThemeOne } from '../utils/constants/Colors';

const Colors2 = ThemeOne;
const windowWidth = Dimensions.get('window').width;

export default function LeftBarItemAdmin({
  name,
  stack,
  screen,
  activeScreen,
  ...props
}) {
  const navigation = useNavigation();
  const route = useRoute();

  const currentScreen = activeScreen || route.name;

  const isActive = currentScreen === screen;

    const color = isActive ? '#fff' : Colors2.top7;

  return (
    <TouchableOpacity
      style={[
        Platform.OS === 'web' && windowWidth >= 600
          ? styles.button
          : styles.buttonMobile,
        {
          borderBottomColor: color,
            backgroundColor: isActive ? Colors2.top7 : 'transparent',
          marginRight: 10
        },
      ]}
      onPress={() =>
        navigation.navigate(stack, {
          screen: screen,
        })
      }
      {...props}
    >
      <Text
        style={[
          Platform.OS === 'web' && windowWidth >= 600
            ? styles.buttonText
            : styles.buttonTextMobile,
          {
            color:'#fff'  ,
          },
        ]}
      >
        {name}
      </Text>
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  button: {
    marginTop: 10,
    left: 5,
    padding: 8,
    borderBottomWidth: 1,
    borderRadius: 4,
  },

  buttonMobile: {
    paddingHorizontal: 8,
    paddingVertical: 6,
    borderRightWidth: 1,
    borderRightColor: '#fff',
    borderRadius: 4,
  },

  buttonText: {
    fontSize: 16,
    fontWeight: 'bold',
    fontFamily: 'SolaimanLipi',
  },

  buttonTextMobile: {
    fontSize: 14,
    fontWeight: 'bold',
    fontFamily: 'SolaimanLipi',
  },
});